import { useFlags } from 'launchdarkly-react-client-sdk';
import { useContext } from 'react';
import { AddRuleButton } from '../RulesManager';
import { NavigationRulesContext } from './NavigationRulesManagerContext';

export interface AddNavigationRuleButtonProps {
  onSelect: () => void;
}
export const AddNavigationRuleButton = ({
  onSelect,
}: AddNavigationRuleButtonProps) => {
  const { rules } = useContext(NavigationRulesContext);
  const { editorRulesAndVarsLimit } = useFlags();

  const reachedLimit = rules.length >= editorRulesAndVarsLimit;

  return (
    <AddRuleButton
      onClick={() => onSelect()}
      disabled={reachedLimit}
      tooltipMessage={
        reachedLimit &&
        `You reached the limit of ${editorRulesAndVarsLimit} rules`
      }
    />
  );
};
